import React from 'react';
import { ReactRenderer } from '@atlaskit/renderer';
import { prefixDocumentWithStatusNode } from './utils';
export const LatestPromptRenderer = ({
  promptADF,
  providerFactory,
  presetTitle,
  schema
}) => {
  const jsonDocument = prefixDocumentWithStatusNode(promptADF, schema, presetTitle);
  return /*#__PURE__*/React.createElement(ReactRenderer, {
    document: jsonDocument,
    media: {
      // We don't currently support images with captions
      allowLinking: false
    }
    // By default -- the renderer uses a "default schema" which supports all
    // the nodes and marks the markdown transformer can create.
    // see packages/editor/adf-schema/src/schema/default-schema.ts for details.
    ,
    useSpecBasedValidator: true,
    dataProviders: providerFactory
  });
};